import { jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { useRef, useEffect } from "react";
import { grid } from "./Grid.css.mjs";
const useStickyDetection = ({
  onIsSticky
}) => {
  const stickyDetectionRef = useRef(null);
  const lastScrollDirectionRef = useRef(null);
  useEffect(() => {
    const checkStickyState = () => {
      if (!onIsSticky) return;
      const stickyElement = stickyDetectionRef.current;
      if (!stickyElement) return;
      const computedStyle = window.getComputedStyle(stickyElement);
      const offsetTop = stickyElement.getBoundingClientRect().top;
      const isCurrentlySticky = parseFloat(computedStyle.top) === offsetTop;
      const lastDirection = lastScrollDirectionRef.current;
      if (lastDirection === "down" && isCurrentlySticky) {
        onIsSticky(true);
      } else if (lastDirection === "up" && !isCurrentlySticky) {
        onIsSticky(false);
      }
    };
    const handleWheel = (event) => {
      if (event.deltaY > 0) {
        lastScrollDirectionRef.current = "down";
      } else if (event.deltaY < 0) {
        lastScrollDirectionRef.current = "up";
      }
      checkStickyState();
    };
    const handleKeyDown = (event) => {
      if (event.code === "ArrowDown" || event.code === "Space") {
        lastScrollDirectionRef.current = "down";
      } else if (event.code === "ArrowUp") {
        lastScrollDirectionRef.current = "up";
      }
      checkStickyState();
    };
    window.addEventListener("wheel", handleWheel);
    window.addEventListener("resize", checkStickyState);
    window.addEventListener("keydown", handleKeyDown);
    checkStickyState();
    return () => {
      window.removeEventListener("wheel", handleWheel);
      window.removeEventListener("resize", checkStickyState);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onIsSticky]);
  return { stickyDetectionRef };
};
const Grid = ({
  children,
  className,
  onIsSticky
}) => {
  const { stickyDetectionRef } = useStickyDetection({ onIsSticky });
  return /* @__PURE__ */ jsx(Box, { ref: stickyDetectionRef, className: [grid, className], children });
};
export {
  Grid
};
